class DocCookies {
    static hasItem(key: string) {
        return new RegExp(
            '(?:^|;\\s*)' + encodeURIComponent(key).replace(/[-.+*]/g, '\\$&') + '\\s*\\='
        ).test(document.cookie);
    }

    static removeItem({ key, path, domain }: { key: string; path?: string; domain?: string }) {
        if (!key || !DocCookies.hasItem(key)) {
            return false;
        }

        // When the expires is set to Thu, 01 Jan 1970 00:00:00 GMT, the cookie will be deleted
        document.cookie = `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${
            domain ? '; domain=' + domain : ''
        }${path ? '; path=' + path : ''}`;

        return true;
    }
}

export default DocCookies;
